import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';

import {
  TXTWCL_Back_to_Cashier,
  TXTWCL_Deposits_canXt_be_processed_ri_ELL,
  TXTWCL_WeXre_sorry_for_any_inconvenie_ELL,
  TXTWCL_You_canXt_deposit_right_now
} from './DepositLugasBlocked.messages.json';

interface Props {
  wizardError?: boolean;
  errorMessage?: string;
}

const DepositLugasBlocked: React.FC<Props> = () => (
  <>
    <Translation tagName="h2" {...TXTWCL_You_canXt_deposit_right_now} />
    <p>
      <Translation {...TXTWCL_Deposits_canXt_be_processed_ri_ELL} />{' '}
      <Translation {...TXTWCL_WeXre_sorry_for_any_inconvenie_ELL} />
    </p>

    <CTAButton type="button" alias="firstWalletHome" translation={TXTWCL_Back_to_Cashier} />
  </>
);

export default DepositLugasBlocked;
